import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import React from "react"

export function DesktopIcon(){
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height={"1em"} viewBox="0 0 576 512" fill="currentColor">
            <path d="M512 48H64c-8.8 0-16 7.2-16 16V256H528V64c0-8.8-7.2-16-16-16zm64 208v48 48c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H352 224 152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48H64c-35.3 0-64-28.7-64-64V304 256 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V256zM48 304v48c0 8.8 7.2 16 16 16H239.5c.3 0 .6 0 .8 0h95.2c.3 0 .6 0 .8 0H512c8.8 0 16-7.2 16-16V304H48zM252.3 464h71.3l-8-48H260.3l-8 48z"/></svg>
    )
}

export function TabletIcon(){
    return(
    <svg xmlns="http://www.w3.org/2000/svg" height={"1em"}  viewBox="0 0 448 512" fill="currentColor">
    <path d="M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/></svg>

    )
}

export function MobileIcon(){

    return(
    <svg xmlns="http://www.w3.org/2000/svg" height={"1em"}  viewBox="0 0 384 512" fill="currentColor">
    <path d="M80 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H80zM16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM160 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/></svg>
    )

}

export function GetScreensizeIcon({screenSize}:{screenSize:ScreenSize}){

    switch(screenSize){
        case ScreenSize.Desktop:
            return <DesktopIcon/>
        case ScreenSize.Tablet:
            return <TabletIcon/>
        case ScreenSize.Mobile:
            return <MobileIcon/>

        default:
            return <DesktopIcon/>

    }

}